import { FaqItem, StoreInfo } from "./props";

export function generateFaq(store: StoreInfo): FaqItem[] {
  const { name, city, stockType } = store;

  const hasRegion = city && city.toLowerCase() !== "brasil";
  const regional = (txt: string) => (hasRegion ? txt : "");

  const carFaq: FaqItem[] = [
    {
      question: `É confiável comprar na ${name}?`,
      answer: `Sim. A ${name} segue o Código de Defesa do Consumidor${regional(
        ` e vende carros vistoriados em ${city}`
      )}, oferecendo compra segura.`,
    },
    {
      question: `Como funciona o financiamento de carro na ${name}?`,
      answer:
        "Você simula online ou na loja; bancos parceiros analisam renda e score e podem aprovar crédito sem entrada em até 60 meses.",
    },
    {
      question: "Quais documentos preciso para transferir o carro?",
      answer:
        "CRV/DUT preenchido, RG, CPF, comprovante de endereço e guias pagas de IPVA, licenciamento e vistoria ECV exigidas pelo Detran local.",
    },
    {
      question: "Qual garantia recebo ao comprar um carro usado?",
      answer:
        "Todo seminovo tem 90 dias de garantia legal (Art. 26 CDC); a loja oferece opção de garantia estendida para motor e câmbio.",
    },
    {
      question: "O que verificar antes de comprar o carro?",
      answer:
        "Analise histórico de manutenção, quilometragem, lataria, pneus, eletrônicos e faça vistoria cautelar para evitar sinistros ou restrições.",
    },
    {
      question: "IPVA atrasado impede transferência?",
      answer:
        "Sim. Para concluir a transferência é obrigatório quitar IPVA, licenciamento e multas em aberto; sem isso o Detran bloqueia a emissão do novo CRLV.",
    },
    {
      question: "Como saber se o carro tem sinistro?",
      answer:
        "Consulte a placa ou chassi em serviços do Detran ou laudos cautelares; eles indicam registros de batidas, perda total ou indenizações de seguradora.",
    },
  ];

  const motoFaq: FaqItem[] = [
    {
      question: `É segura a compra de moto na ${name}?`,
      answer: `Sim. A ${name} confere chassi, laudos de roubo/furto e regularidade no Detran antes de vender motos${regional(
        ` em ${city}`
      )}.`,
    },
    {
      question: "Como financiar uma moto sem entrada?",
      answer:
        "Bancos parceiros oferecem planos sem entrada para motos até 5 anos; a taxa e o prazo dependem da análise de crédito e renda.",
    },
    {
      question: "Quais documentos para transferir a moto?",
      answer:
        "CRV preenchido, RG, CPF, comprovante de endereço e laudo de vistoria; taxas variam conforme o Detran do estado.",
    },
    {
      question: "Moto usada tem garantia de 90 dias?",
      answer:
        "Sim, o CDC assegura 90 dias contra defeitos ocultos; é possível contratar garantia estendida para motor e caixa.",
    },
    {
      question: "O que revisar antes de comprar moto usada?",
      answer:
        "Verifique alinhamento de quadro, pneus, corrente, vazamentos, quilometragem e faça perícia cautelar com test-ride para ruídos anormais.",
    },
    {
      question: "IPVA atrasado impede transferência de moto?",
      answer:
        "Sim. É necessário quitar IPVA, licenciamento e multas para transferir a propriedade; o Detran bloqueia o novo CRLV até regularização.",
    },
    {
      question: "Qual cilindrada ideal para iniciantes?",
      answer:
        "Modelos entre 150 cc e 300 cc equilibram potência, peso e consumo, facilitando o controle para quem está começando.",
    },
  ];

  if (stockType === "car") return carFaq;
  if (stockType === "motorcycle") return motoFaq;

  return [...carFaq, ...motoFaq];
}
